/*
 *
 * Announcement
 *
 */

import {OPEN_BAR, CLOSE_BAR, OPEN_DIALOG, CLOSE_DIALOG, SET_IMAGE_LINK} from './constants';


export function openBar(info) {
    const {id, name, content, date, file} = info
    return {
        type: OPEN_BAR,
        payload: {id, name, content, date, file},
    };
}

export function closeBar() {
    return {
        type: CLOSE_BAR,
    };
}

export function openDialog() {
    return {
        type: OPEN_DIALOG,
    };
}

export function closeDialog() {
    return {
        type: CLOSE_DIALOG,
    };
}

export function setImageLink(link, meta) {
    console.log(link, meta)
    return {
        type: SET_IMAGE_LINK,
        meta,
        payload: {link},
    };
}